import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatQAR } from "../lib/money";
export function FinancialsPanel({ theCase, onCaseUpdated }) {
    const [recoveries, setRecoveries] = useState([]);
    const [settlements, setSettlements] = useState([]);
    const [error, setError] = useState(null);
    const [openForm, setOpenForm] = useState(null);
    const [busy, setBusy] = useState(false);
    const [recAmount, setRecAmount] = useState("");
    const [recMode, setRecMode] = useState("Bank Transfer");
    const [recRef, setRecRef] = useState("");
    const [propAmount, setPropAmount] = useState("");
    const [waiverPct, setWaiverPct] = useState("");
    const [settleReason, setSettleReason] = useState("");
    const [recErrors, setRecErrors] = useState({});
    const [settleErrors, setSettleErrors] = useState({});
    function load() {
        api
            .get(`/cases/${theCase.id}/recoveries`)
            .then((r) => setRecoveries(r.items))
            .catch(() => { });
        api
            .get(`/cases/${theCase.id}/settlements`)
            .then((r) => setSettlements(r.items))
            .catch(() => { });
    }
    useEffect(load, [theCase.id]);
    async function submitRecovery() {
        const amount = Number(recAmount);
        const errs = {};
        if (!recAmount || Number.isNaN(amount) || amount <= 0)
            errs.amount = "Enter an amount greater than zero.";
        setRecErrors(errs);
        if (Object.keys(errs).length)
            return;
        setBusy(true);
        setError(null);
        try {
            const result = await api.post(`/cases/${theCase.id}/recoveries`, {
                recoveryDate: new Date().toISOString(),
                amount,
                paymentType: "Recovery",
                paymentMode: recMode,
                referenceNumber: recRef || undefined,
            });
            onCaseUpdated(result.case);
            setRecAmount("");
            setRecRef("");
            setRecErrors({});
            setOpenForm(null);
            load();
        }
        catch {
            setError("Couldn't record the recovery.");
        }
        finally {
            setBusy(false);
        }
    }
    async function submitSettlement() {
        const proposedAmount = Number(propAmount);
        const waiverPercentage = Number(waiverPct);
        const errs = {};
        if (!propAmount || Number.isNaN(proposedAmount) || proposedAmount < 0)
            errs.proposedAmount = "Enter a proposed amount of zero or more.";
        if (!waiverPct || Number.isNaN(waiverPercentage) || waiverPercentage <= 0 || waiverPercentage > 100)
            errs.waiverPct = "Waiver % must be between 0 and 100.";
        if (!settleReason.trim())
            errs.reason = "A reason is required.";
        setSettleErrors(errs);
        if (Object.keys(errs).length)
            return;
        const waiverAmount = (theCase.financialSummary.outstandingBalance * waiverPercentage) / 100;
        setBusy(true);
        setError(null);
        try {
            await api.post(`/cases/${theCase.id}/settlements`, {
                originalOutstanding: theCase.financialSummary.outstandingBalance,
                proposedAmount,
                waiverAmount,
                waiverPercentage,
                reason: settleReason,
            });
            setPropAmount("");
            setWaiverPct("");
            setSettleReason("");
            setSettleErrors({});
            setOpenForm(null);
            load();
        }
        catch {
            setError("Couldn't submit the settlement proposal.");
        }
        finally {
            setBusy(false);
        }
    }
    return (<div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 16, marginBottom: 20 }}>
        <Field label="Original Receivable" value={formatQAR(theCase.financialSummary.originalReceivable)}/>
        <Field label="Other Charges" value={formatQAR(theCase.financialSummary.otherCharges)}/>
        {theCase.financialSummary.waivedAmount > 0 && (<Field label="Waived / Written Off" value={`− ${formatQAR(theCase.financialSummary.waivedAmount)}`}/>)}
        <Field label="Recovery %" value={`${theCase.financialSummary.recoveryPercentage.toFixed(2)}%`}/>
      </div>

      {error && <div style={{ color: "var(--st-risk)", fontSize: "0.85rem", marginBottom: 12 }}>{error}</div>}

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <button onClick={() => setOpenForm(openForm === "recovery" ? null : "recovery")} style={actionBtn}>
          Record Recovery
        </button>
        <button onClick={() => setOpenForm(openForm === "settlement" ? null : "settlement")} style={actionBtn}>
          Propose Settlement
        </button>
      </div>

      {openForm === "recovery" && (<div className="lg-stack" style={formBox}>
          <div>
            <input placeholder="Amount (QAR)" type="number" value={recAmount} onChange={(e) => setRecAmount(e.target.value)} style={inputStyle}/>
            {recErrors.amount && <div style={errText}>{recErrors.amount}</div>}
          </div>
          <select value={recMode} onChange={(e) => setRecMode(e.target.value)} style={inputStyle}>
            <option>Bank Transfer</option>
            <option>Cheque</option>
            <option>Cash</option>
            <option>Court Deposit</option>
          </select>
          <input placeholder="Reference (optional)" value={recRef} onChange={(e) => setRecRef(e.target.value)} style={inputStyle}/>
          <button onClick={submitRecovery} disabled={busy} style={actionBtn}>
            Save
          </button>
        </div>)}

      {openForm === "settlement" && (<div className="lg-stack" style={formBox}>
          <div>
            <input placeholder="Proposed amount (QAR)" type="number" value={propAmount} onChange={(e) => setPropAmount(e.target.value)} style={inputStyle}/>
            {settleErrors.proposedAmount && <div style={errText}>{settleErrors.proposedAmount}</div>}
          </div>
          <div>
            <input placeholder="Waiver %" type="number" value={waiverPct} onChange={(e) => setWaiverPct(e.target.value)} style={inputStyle}/>
            {settleErrors.waiverPct && <div style={errText}>{settleErrors.waiverPct}</div>}
          </div>
          <div style={{ gridColumn: "1 / -1" }}>
            <textarea placeholder="Reason" value={settleReason} onChange={(e) => setSettleReason(e.target.value)} rows={2} style={{ ...inputStyle, width: "100%" }}/>
            {settleErrors.reason && <div style={errText}>{settleErrors.reason}</div>}
          </div>
          <button onClick={submitSettlement} disabled={busy} style={actionBtn}>
            Submit for approval
          </button>
        </div>)}

      <h4 style={{ fontSize: "0.8rem", color: "var(--ink-faint)", textTransform: "uppercase", margin: "20px 0 10px" }}>
        Recovery Transactions
      </h4>
      {recoveries.map((t) => (<div key={t.id} style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderTop: "1px solid var(--line-soft)", fontSize: "0.85rem" }}>
          <span>
            {new Date(t.recoveryDate).toLocaleDateString()} · {t.paymentMode}
            {t.referenceNumber ? ` · ${t.referenceNumber}` : ""}
          </span>
          <span className="mono tabnum">{formatQAR(t.amount)}</span>
        </div>))}
      {recoveries.length === 0 && <div style={{ color: "var(--ink-faint)", fontSize: "0.85rem" }}>No recovery transactions recorded yet.</div>}

      <h4 style={{ fontSize: "0.8rem", color: "var(--ink-faint)", textTransform: "uppercase", margin: "20px 0 10px" }}>
        Settlement Proposals
      </h4>
      {settlements.map((s) => (<div key={s.id} style={{ padding: "9px 0", borderTop: "1px solid var(--line-soft)", fontSize: "0.85rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Proposed {formatQAR(s.proposedAmount)} ({s.waiverPercentage.toFixed(2)}% waiver)</span>
            <span className="mono" style={{ color: "var(--ink-faint)" }}>{new Date(s.createdAt).toLocaleDateString()}</span>
          </div>
          <div style={{ color: "var(--ink-soft)", fontSize: "0.8rem", marginTop: 2 }}>{s.reason}</div>
        </div>))}
      {settlements.length === 0 && <div style={{ color: "var(--ink-faint)", fontSize: "0.85rem" }}>No settlement proposals yet.</div>}
    </div>);
}
function Field({ label, value }) {
    return (<div>
      <div className="mono" style={{ fontSize: "0.66rem", color: "var(--ink-faint)", textTransform: "uppercase" }}>
        {label}
      </div>
      <div style={{ fontSize: "0.88rem", marginTop: 4 }}>{value}</div>
    </div>);
}
const actionBtn = {
    border: "1px solid var(--line)",
    background: "var(--surface)",
    color: "var(--ink-soft)",
    fontWeight: 600,
    fontSize: "0.8rem",
    padding: "8px 14px",
    borderRadius: 8,
    cursor: "pointer",
};
const formBox = {
    border: "1px solid var(--line-soft)",
    borderRadius: 8,
    padding: 14,
    marginBottom: 16,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 8,
};
const inputStyle = {
    border: "1px solid var(--line)",
    borderRadius: 8,
    padding: "8px 10px",
    fontSize: "0.82rem",
    fontFamily: "inherit",
    width: "100%",
};
const errText = { color: "var(--st-risk)", fontSize: "0.7rem", marginTop: 3 };
